import { Badge } from '@/components/ui/Badge';
import type { TransferStatus } from './types';

const LABEL: Record<TransferStatus, string> = {
  issued: 'In transit', received: 'Received', partially_received: 'Received short', cancelled: 'Cancelled',
};
const VARIANT: Record<TransferStatus, 'info' | 'success' | 'warn' | 'neutral'> = {
  issued: 'info', received: 'success', partially_received: 'warn', cancelled: 'neutral',
};

export function TransferStatusBadge({ status }: { status: TransferStatus }) {
  return <Badge variant={VARIANT[status]}>{LABEL[status]}</Badge>;
}
